import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { LmsService } from "src/app/_Lms/services/lms.service";
import * as moment from "moment";
import { MasterService } from "src/app/Shared/app.Masters.Service";
import { MatTableDataSource } from "@angular/material/table";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { FormsModule } from "@angular/forms";
import { Observable } from "rxjs";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { MatPaginator } from "@angular/material/paginator";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
import { MatSort } from "@angular/material/sort";
declare var $: any;

@Component({
  selector: "app-vehicle-dealer-manufacture",
  templateUrl: "./vehicle-dealer-manufacture.component.html",
  styleUrls: ["./vehicle-dealer-manufacture.component.scss"],
})
export class VehicleDealerManufactureComponent implements OnInit {
  startyear: Date;
  showSpinner: boolean = false;
  currentUser: any;
  DealerList: any;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  dataSource: any;
  getStartYear: Date;
  DealerId: any;
  DealerName: any;
  private _MasterService;
  vehicleCategory: any = [];
  displayedColumns: string[] = [
    "PartnerId",
    "Partner",
    "MobileNo",
    "Manufactures",
    "Edit",
  ];
  RequestModel: RequestModel = new RequestModel();
  vehicleDealerManufactureDetail: any = [];
  ManufactureData: any;
  constructor(
    private route: ActivatedRoute,
    private lmsService: LmsService,
    private snackBar: MatSnackBar,
    private MasterService: MasterService,
    private dataSharingService: DataSharingService
  ) {
    this._MasterService = MasterService;
  }

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Vehicle Dealer Manufacture");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.GetData();

  }
  GetData() {
    this.RequestModel.PartnerType = "Dealer";
    this._MasterService.Get_PartnerList(this.RequestModel).subscribe(
      (result: any) => {

        this.DealerList = JSON.parse(JSON.stringify(result));
        this.dataSource = new MatTableDataSource(this.DealerList);
        console.log("Data Source", this.dataSource);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.showSpinner = false;
        this._MasterService
          .GetManufactureForDropdown({})
          .subscribe((response: any) => {
            this.ManufactureData = response;
          });

      }
    );
  }
  exportTable(exporter: any) {
    exporter.exportTable("xls", {
      fileName: `Dealer-${this.RequestModel.PartnerType}-list`,
      sheet: "Dealer",
    });
  }
  OnOpenPartnerModal(data: any, e: any = null) {
    this.vehicleDealerManufactureDetail = [];
    this.vehicleCategory[0] = [];
    this.DealerId = data.PartnerId;
    this.DealerName = data.Partner;
    this._MasterService
      .Get_Vehicle_Dealer_Manufacture_Map({ Dealer_Id: this.DealerId  })
      .subscribe((response: any) => {
        if (response.length > 0) {
          response.forEach((obj: any, i: any) => {
            this._MasterService
              .GetVehicleCategoryForDropdown({ ManufactureId: obj.Manufacture })
              .subscribe((response: any) => {
                this.vehicleCategory[i] = response;
                obj.Category = obj.VehicleCategory.split(',').map(item => Number(item.trim()));
              });
            
            
          })
          console.log("this.response", response);
          this.vehicleDealerManufactureDetail = response;
          console.log("this.vehicleDealerManufactureDetail", this.vehicleDealerManufactureDetail);
          $("#AssignVehiclemanufactureModel").modal("show");
          $("#AssignVehiclemanufactureModel").css("z-index", "1050");
        } else {
          var PolicyObj = { Manufacture: '', Category: '' };
          this.vehicleDealerManufactureDetail.push(PolicyObj);
          $("#AssignVehiclemanufactureModel").modal("show");
          $("#AssignVehiclemanufactureModel").css("z-index", "1050");
        }
      })
    
   
   
  }
  onCloseModal() {
    this.DealerId = null;
    this.DealerName = null;
    $("#AssignVehiclemanufactureModel").modal("hide");

  }
  LMS_GetVehicleMaster(row, i) {
    //this._LmsService.Get_Lms_VehicleMaster().subscribe((response) => {
    //  this.vehicleCategory = response;
    //});
    var _find = this.vehicleDealerManufactureDetail.find((obj: any, index: any) => {
      return index != i && obj.Manufacture == row.Manufacture;
    });
    if (_find) {
      this.vehicleDealerManufactureDetail[i].Manufacture = '';
      this.snackBar.openFromComponent(SnackbarComponent, { data: 'Manufacture Already Exists', ...this.configSuccess });
    } else {
      this._MasterService
        .GetVehicleCategoryForDropdown({ ManufactureId: row.Manufacture })
        .subscribe((response: any) => {
          this.vehicleCategory[i] = response;
        });
    }
  }
  removeData(index: any) {
    this.vehicleDealerManufactureDetail.splice(index, 1);
  }
  addMoreData(row) {
    var PolicyObj = { Manufacture: '', Category: '' };
    this.vehicleDealerManufactureDetail.push(PolicyObj);
  }
  onSavevehicleDealerManufactureDetail() {
    this.showSpinner = true;
    console.log("this.vehicleDealerManufactureDetail", this.vehicleDealerManufactureDetail);
    this.vehicleDealerManufactureDetail.forEach((obj: any) => {
      obj.VehicleCategoryIds = obj.Category.join(',')
    })
    this._MasterService
      .Save_Vehicle_Dealer_Manufacture_Map({
        Dealer_Id: this.DealerId, LoginUserId: this.currentUser.userId, JSON: JSON.stringify({
          Vehicle_Dealer_Manufacture: this.dataSharingService.cleanObject(this.vehicleDealerManufactureDetail)
        }),
      })
      .subscribe((response: any) => {
        if (response.length > 0) {
          if (response[0].CODE == 0) {
            this.showSpinner = false;
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
            this.GetData();
            this.onCloseModal();
           
          } else {
            this.showSpinner = false;
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
          }
        }


      });
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
